import { render, staticRenderFns } from "./PhysicalTherapy.vue?vue&type=template&id=5357f001&scoped=true&"
import script from "./PhysicalTherapy.vue?vue&type=script&lang=js&"
export * from "./PhysicalTherapy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5357f001",
  null
  
)

export default component.exports